import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const Cards = ({data, values, labels}) => {

    useEffect(() => {
        ReportUtils.createExportableTable(labels, values, `Lista de eventos`);
    }, [data]);

    return (
        <>
            <div className="grid grid-cols-3 gap-2">
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Total de eventos</h3><h2>{data[0].total}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Eventos pendentes</h3><h2>{data[0].pending_events}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer">
                            <h3>Tempo médio de encerramento</h3><h2>{data[0].closure_avg_time}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default Cards;